<template>
  <div>
    <div v-if="!pageLoading">
      <!--    <back-nav to="PersonalDetailsHealth" />-->
      <v-card flat class="tw-mt-5 md:tw-mt-16">
        <div class="tw-px-4 md:tw-px-8">
          <card-title icon="mdi-account">Quote Summary</card-title>
          <v-card flat color="primary" class="c-bg-navy tw-p-3 md:tw-p-6 rounded-lg tw-mt-5">
            <div class="tw-flex tw-flex-wrap md:tw-flex-no-wrap tw-items-center">
              <div class="tw-w-full md:tw-w-1/4">
                <v-icon size="80" color="white" class="">mdi-hospital-box-outline</v-icon>
                <br>
                <div class="tw-w-full tw-mt-3">
                  <p class="tw-text-white">PACIS AMANI COVER</p>
                </div>
              </div>
              <div class="tw-text-white">
                <div class="tw-flex tw-flex-wrap tw-mb-3">
                  <p class="tw-py-2 tw-text-sm tw-w-full md:tw-w-1/2 md:tw-border-r md:tw-border-white tw-px-2 md:tw-px-4">It provides coverage for medical expenses arising out of an illness or an injury subject to the benefit limits.</p>
                  <div class="tw-px-2 md:tw-px-4">
                    <span v-if="quote.inpatient_limit"><v-icon size="15" color="white">mdi-check-circle</v-icon> <small class="tw-text-white">Inpatient Cover</small><br></span>
                    <span v-if="quote.outpatient_limit"><v-icon size="15" color="white">mdi-check-circle</v-icon> <small class="tw-text-white">Outpatient Cover</small> <br></span>
                    <span v-if="quote.maternity_limit"><v-icon size="15" color="white">mdi-check-circle</v-icon> <small class="tw-text-white">Maternity Cover</small> <br></span>
                    <span v-if="quote.dental_limit"><v-icon size="15" color="white">mdi-check-circle</v-icon> <small class="tw-text-white">Dental Cover</small> <br></span>
                    <span v-if="quote.optical_limit"><v-icon size="15" color="white">mdi-check-circle</v-icon> <small class="tw-text-white">Optical Cover</small> <br></span>
                  </div>
                </div>
                <hr>
                <!-- <p class="tw-text-white tw-font-bold tw-mt-3">Current Limit: Ksh {{ totalLimit }}</p> -->
                <h5 class="w-full c-blue-text tw-text-xl tw-font-bold">Premium Payable: Ksh {{ quote.cover_premium | formatNum }}</h5>
              </div>
            </div>
          </v-card>
          <card-title icon="mdi-account">Personal Details</card-title>
          <div class="tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
            <v-form v-model="isValid">
              <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-3">
                <v-text-field
                    v-model="form.first_name"
                    class="my-2 tw-px-0 md:tw-px-6"
                    label="First Name"
                    type="text"
                    :rules="[required('First Name')]"
                ></v-text-field>
                <v-text-field
                    v-model="form.last_name"
                    class="my-2 tw-px-0 md:tw-px-6"
                    label="Last Name"
                    type="text"
                    :rules="[required('Last Name')]"
                ></v-text-field>
                <v-text-field
                    v-model="form.phone_number"
                    class="my-2 tw-px-0 md:tw-px-6"
                    label="Mobile No."
                    type="text"
                    :rules="[required('Mobile No.'), mobileFormat()]"
                ></v-text-field>
                <v-text-field
                    v-model="form.email"
                    class="my-2 tw-px-0 md:tw-px-6"
                    label="Email"
                    type="text"
                    :rules="[required('Email'), emailFormat()]"
                ></v-text-field>
                <v-text-field
                    v-model="form.id_number"
                    class="my-2 tw-px-0 md:tw-px-6"
                    label="ID No."
                    type="number"
                    :rules="[required('ID No.'), minLength('ID No.',6), maxLength('ID NO.', 8)]"
                ></v-text-field>
                <v-radio-group v-model="form.gender" class="my-2 tw-px-0 md:tw-px-6" :rules="[required('Gender')]"  row>
                  <v-radio label="Male" value="M" class="tw-mt-0 md:tw-mt-5 tw-pr-10"></v-radio>
                  <v-radio label="Female" value="F" class="tw-mt-0 md:tw-mt-5"></v-radio>
                </v-radio-group>
                 <!-- <express-upload :uid="authenticatedUser['custom:kra-pin']" :phoneNumber="authenticatedUser.phone_number" :fullName="authenticatedUser.name" :email="authenticatedUser.email" name="KRA PIN" :bucket="bucket" />
                <express-upload :uid="authenticatedUser['custom:kra-pin']" :phoneNumber="authenticatedUser.phone_number" :fullName="authenticatedUser.name" :email="authenticatedUser.email" name="National ID" :bucket="bucket"/>
                <express-upload :uid="authenticatedUser['custom:kra-pin']" :phoneNumber="authenticatedUser.phone_number" :fullName="authenticatedUser.name" :email="authenticatedUser.email" name="Application form" :bucket="bucket" /> -->
              </div>
              <div class="tw-w-full">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Are you a direct client or referred to us by an Agent?</h3>
              <hr class="tw-mt-3 tw-mb-5">

              <v-radio-group class="my-2 tw-px-0 md:tw-px-6" v-model="form.agent_option" :rules="[v => !!v || 'Selection choice is required']" row>
                <v-radio label="Direct client" :value="1" class="tw-mt-0 md:tw-mt-5 tw-pr-10"></v-radio>
                <v-radio label="Referred by Agent" :value="2" class="tw-mt-0 md:tw-mt-5"></v-radio>
              </v-radio-group>
          </div>
          <div v-if="form.agent_option === 2">
              <v-autocomplete
                id="agentList2"
                v-model="agent"
                :loading="agentLoading"
                :items="agentListItems"
                :search-input.sync="agentListSearch"
                class="tw-w-full md:tw-w-1/2 tw-mt-6 md:tw-mt-0 mx-4"
                hide-no-data
                hide-details
                label="Agent"
                :rules="[required('Agent')]"
            ></v-autocomplete>
            </div>

              <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-3">
                <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="form.cover_from"
                        label="Cover Start Date"
                        persistent-hint
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="tw-px-0 md:tw-px-6"
                        :rules="[required('Cover Start Date')]"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" :min="new Date().toISOString().substr(0, 10)" no-title @input="menu = false" color="primary"></v-date-picker>
                </v-menu>
              </div>
              <div v-if="quote.principal_age >= 55 || quote.spouse_age >= 55" class="tw-px-0 md:tw-px-6 tw-mt-0 md:tw-mt-4 tw-flex tw-space-x-2">
                <v-checkbox v-model="checked1" :rules="[check()]">
                  <template #label>
                    <span class="c-gray-text">Members above 55 years require medical examination.</span>
                  </template>
                </v-checkbox> <a href="/docs/pacis_medical_exam_form.pdf" target="_blank" rel="noopener noreferrer" class="tw-underline" download>Download Form</a>
              </div>
              <div class="tw-px-0 md:tw-px-6 tw-mt-0">
                <v-checkbox v-model="checked" :rules="[check()]">
                  <template #label>
                    <terms-and-conditions pre="I have" post="of the policy & I agree to the same" />
                  </template>
                </v-checkbox>
              </div>

              <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
                <v-btn block large
                       color="secondary"
                       class="my-3 "
                       :loading="loading"
                       @click="proceed"
                       :disabled="!isValid"
                >
                  {{ isValid ? 'Proceed To Payment' : 'Check if all fields are filled' }}
                </v-btn>
              </v-card-actions>

            </v-form>
          </div>
        </div>
      </v-card>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="80"
          color="primary1"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import CardTitle from '@/components/shared/CardTitle';
import validations from '@/utils/validations';
import { formatDate } from '@/utils/time';
import { mapGetters } from 'vuex';
import axios from 'axios';
import helpers from '@/utils/helpers';
import TermsAndConditions from '@/components/TermsAndConditions';
// import ExpressUpload from '@/components/shared/ExpressUpload';

export default {
  name: 'PersonalDetailsHealth',
  // components: { TermsAndConditions, CardTitle, ExpressUpload },
  components: { TermsAndConditions, CardTitle },
  data() {
    return {
      pageLoading: true,
      loading: false,
      isValid: false,
      checked: false,
      checked1: false,
      ...validations,
      date: '',
      menu: false,
      form: {
        first_name: '',
        middle_name: '',
        id_number: '',
        last_name: '',
        phone_number: '',
        gender: '',
        cover_from: '',
        agent_id: '',
      },
      quote: null,
      bucket: 'medical',
      agentList2: [],
      agent: null,
      agentObj: {},
      agentListSearch: null,
      agentListItems: [],
      agentLoading: false,
      agentId: 0,
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    date(_val) {
      this.form.cover_from = this.formatDate(this.date);
    },
    async agentListSearch(val) {
      // eslint-disable-next-line no-unused-expressions
      val && val !== this.agentList2 && this.agentListFilter(val);

      this.agentObj = await this.agentList2.find((x) => x.agencyName === this.agent);
      this.agentId = this.agentObj.agencyCode;
    },
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'authenticatedUser']),
    totalLimit() {
      const { quote } = this;
      let sum = 0;
      if (('inpatient_limit' in quote) && quote.inpatient_limit) sum += quote.inpatient_limit;
      if (('outpatient_limit' in quote) && quote.outpatient_limit) sum += quote.outpatient_limit;
      if (('maternity_limit' in quote) && quote.maternity_limit) sum += quote.maternity_limit;
      if (('dental_limit' in quote) && quote.dental_limit) sum += quote.dental_limit;
      if (('optical_limit' in quote) && quote.optical_limit) sum += quote.optical_limit;
      return helpers.numberToString(sum);
    },
  },
  async mounted() {
    await this.getQuote();
    this.getagentList();
    const user = this.authenticatedUser;
    const names = user.name.split(' ');
    await this.updateQuoteWithEmail();
    this.form = {
      first_name: names[0],
      middle_name: names.length > 2 ? names[1] : '',
      last_name: names.length > 2 ? names[2] : names[1],
      id_number: user['custom:id_number'] || '',
      phone_number: user.phone_number || '',
      email: user.email,
    };
  },
  methods: {
    selectAgentID() {
      if (this.form.agent_option === 1) {
        this.agentId = '0';
      }
    },
    async getQuote() {
      const quote = this.$route.query.q;
      axios.get(`customer/digital-quotation/pacis-amani/quotes/${quote}`).then((response) => {
        this.pageLoading = false;
        this.quote = response.data;
      });
    },
    async updateQuoteWithEmail() {
      const user = this.authenticatedUser;
      const quote = this.$route.query.q;
      axios.patch(`customer/digital-quotation/pacis-amani/quotes/${quote}?email_address=${user.email}`).then((response) => {
        this.pageLoading = false;
        this.quote = response.data;
      });
    },
    proceed() {
      this.loading = true;
      const y = { agent_id: this.agentId };
      const updateData = Object.assign(y, this.$data.form);
      axios.post('customer/digital-quotation/pacis-amani/policy', { ...updateData, ...{ quote_id: this.quote.id } }).then((resp) => {
        this.loading = false;
        const user = this.authenticatedUser;
        const payment = {
          payableAmount: this.quote.cover_premium,
          kraPin: user['custom:kra-pin'],
          transactionReference: resp.data.id_number,
          customerPhoneNumber: user.phone_number,
          transactionDescription: `PA_rfq-${this.quote.id}`,
        };
        const quoteInfo = {
          coverType: 'Pacis Amani Cover',
          payPercentage: 100,
        };
        this.$emit('to-make-payment', { data: { payment, quoteInfo } });
      });
    },
    formatDate,
    getagentList() {
      this.agentLoading = true;
      axios.get('/customer/gis/coresetups/agencies/all').then((response) => {
        this.agentLoading = false;
        this.agentList2 = response.data.object;
      });
    },
    agentListFilter(v) {
      const agents = [];
      this.agentList2.forEach((agent) => {
        agents.push(agent.agencyName);
      });
      setTimeout(() => {
        this.agentListItems = agents.filter((e) => (e || '').toUpperCase().indexOf((v || '').toUpperCase()) > -1);
      }, 500);
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num || 10000);
    },
  },
};
</script>
